var products_on_page = document.querySelector('.products-on-page');
var next_url = products_on_page.dataset.nextUrl;
var load_more_btn = document.querySelector('.load-more__btn');
var load_more_spinner = document.querySelector('.load-more .loading__spinner');

function loadMoreProducts() {
  load_more_btn.style.display = 'none';
  load_more_spinner.classList.remove('hidden'); // show spinner
  fetch(next_url, { method: 'GET' })
    .then(response => response.text())
    .then(next_page => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(next_page, 'text/html');

      var new_products = doc.querySelector('.products-on-page');
      var new_url = new_products.dataset.nextUrl;
      next_url = new_url;

      products_on_page.insertAdjacentHTML('beforeend', new_products.innerHTML);
       load_more_btn.style.display = 'block';
      load_more_spinner.classList.add('hidden'); // hide spinner
    });
}
